<adaa-item-slider class="my-3" [showPerformance]="showOverall()" [scrollInput]="316" [arrowsInHeader]="true">
    <h5 title class="py-2 vision-perf__title">
        {{ "national_agenda.title" | translate }}
        <b>{{ periodLabel() }}</b>
    </h5>

    <!-- The [performance] host stays a static child: Angular resolves projection
         slots at compile time, so a node behind @if or a structural directive
         falls into the default slot and lands inside the scrolling rail. -->
    <div performance class="vision-perf__overall d-flex flex-column align-items-center" [class.d-none]="!showOverall()">
        @if (overallPerformance(); as overall) {
            <adaa-doughnut
                [size]="'md'"
                [amount]="overall.visionAchievement"
                [colorId]="overallPerfColor"
                [colorizeValue]="true"
                [label]="'landingPage.entity_page.national_target_performance' | translate"
            />

            <button class="vision-perf__targets" (click)="goToNationalTargets()">
                <i class="adaa-icon-console_kpis"></i>
                {{ "common.tables.view" | translate }}
            </button>
        }
    </div>

    @for (item of subGovVisionDirections(); track item.id) {
        <adaa-uae-vision-perf-card *adaaHasPermission="pillarPermission" [data]="item" (cardClicked)="goToPillar($event.id)" />
    }
</adaa-item-slider>
